export enum SideBarType {
  CORPORATE = 'Corporate',
  SETUR = 'Setur',
}
